import React from 'react';
import './App.css';
import MainStage from "./sites/MainStage";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import ScoreListView from "./sites/scorelists/ScoreListView";

import "./style.scss";
import "bootstrap"
import "bootstrap-icons/font/bootstrap-icons.min.css"


function App() {
    const lastRefreshKey = 'lastRefreshKey';

    const lastRefresh = localStorage.getItem(lastRefreshKey);

    if (!lastRefresh){
        localStorage.setItem(lastRefreshKey, Date.now().toString())
        window.location.reload();
    } else {
        const lastRefreshNumber = Number(lastRefresh);
        if (lastRefreshNumber < (Date.now() - 60000)){
            localStorage.setItem(lastRefreshKey, Date.now().toString())
            window.location.reload();
        }
    }

    return (
        <div className="App">
            <BrowserRouter>
            <Routes>
                <Route path={"/"} element={<MainStage/>}/>
                <Route path={"/scorelists"} element={<ScoreListView />}/>
                <Route path={"/scorelists/:eventId"} element={<ScoreListView />}/>
            </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
